import { useTravelerPickerContextV2 } from "../../../../../providers/TravelerPickerContextV2";
import SelectNonEmployeeFlightContent from "./SelectNonEmployeeFlightContent";
import SelectNonEmployeeHotelContent from "./SelectNonEmployeeHotelContent";

export default function SelectNonEmployeeContent() {
  const { type } = useTravelerPickerContextV2();

  switch (type) {
    case "flight":
      return <SelectNonEmployeeFlightContent />;
    case "hotel":
      return <SelectNonEmployeeHotelContent />;
    default:
      return null;
  }
}
